// Data hook of the credit-note door picker: customers and the customer's orders.
import { useEffect, useState } from 'react';
import api from '../../services/api';
import { ORDER_PAGE_SIZE, SEARCH_MIN } from './creditNoteHelpers.mjs';

// Customers + orders. lockedOrder -> that one order's header (its customer comes with it); else the list,
// filtered server-side by customer when one is picked. status: 'loading' | 'ready' | 'error'.
export function useCreditNoteSources({ customerId, lockedOrder, reload, query = '' }) {
  const [customers, setCustomers] = useState([]);
  const [rows, setRows] = useState([]);
  const [found, setFound] = useState([]);   // W13: orders the type-ahead found beyond the newest 200 (kept, so a picked one stays in the list)
  const [status, setStatus] = useState('loading');
  useEffect(() => {
    api.getPartners().then(ps => setCustomers((ps || []).filter(p => p.type === 'Customer'))).catch(() => setCustomers([]));
  }, [reload]);
  useEffect(() => {
    let live = true;
    setStatus('loading'); setRows([]); setFound([]);   // never offer the previous customer's orders while the new list loads
    const load = lockedOrder
      ? api.getSalesOrder(lockedOrder).then(d => (d && d.header ? [{ ...d.header, recognized_value: d.header.recognized_value ?? d.totals?.recognized_value }] : []))
      : api.getSalesOrders({ page_size: ORDER_PAGE_SIZE, partner_id: customerId || '' }).then(d => d?.rows || []);
    load.then(r => { if (live) { setRows(r); setStatus('ready'); } })
      .catch(() => { if (live) { setRows([]); setStatus('error'); } });
    return () => { live = false; };
  }, [customerId, lockedOrder, reload]);
  const q = query.trim();
  useEffect(() => {
    if (lockedOrder || q.length < SEARCH_MIN) return undefined;
    let live = true;
    const h = setTimeout(() => {   // a failed search keeps the list as it is (the first 200 stay usable)
      api.getSalesOrders({ page_size: ORDER_PAGE_SIZE, partner_id: customerId || '', search: q })
        .then(d => { if (live && d && d.rows) setFound(f => [...f, ...d.rows.filter(r => !f.some(x => x.operation_id === r.operation_id))]); }).catch(() => {});
    }, 350);
    return () => { live = false; clearTimeout(h); };
  }, [q, customerId, lockedOrder]);
  return { customers, rows: found.length ? [...rows, ...found] : rows, status };
}
